"use client";

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import associatesListEN from '../locales/en/associatesList';
import associatesListPT from '../locales/pt/associatesList';
import featuresEN from '../locales/en/features';
import featuresPT from '../locales/pt/features';
import footerEN from '../locales/en/footer';
import footerPT from '../locales/pt/footer';
import heroEN from '../locales/en/hero';
import heroPT from '../locales/pt/hero';
import newsEN from '../locales/en/news';
import newsPT from '../locales/pt/news';
import navbarEN from '../locales/en/navbar';
import navbarPT from '../locales/pt/navbar';
import characteristicsEN from '../locales/en/characteristics';
import characteristicsPT from '../locales/pt/characteristics';
import qualityEN from '../locales/en/quality';
import qualityPT from '../locales/pt/quality';
import regionEN from '../locales/en/region';
import regionPT from '../locales/pt/region';
import territoryEN from '../locales/en/territory';
import territoryPT from '../locales/pt/territory';
import organizationEN from '../locales/en/organization';
import organizationPT from '../locales/pt/organization';

const resources = {
  en: {
    translation: {
      ...associatesListEN,
      ...featuresEN,
      ...footerEN,
      ...heroEN,
      ...newsEN,
      ...navbarEN,
      ...characteristicsEN,
      ...qualityEN,
      ...regionEN,
      ...territoryEN,
      ...organizationEN
    },
  },
  pt: {
    translation: {
      ...associatesListPT,
      ...featuresPT,
      ...footerPT,
      ...heroPT,
      ...newsPT,
      ...navbarPT,
      ...characteristicsPT,
      ...qualityPT,
      ...regionPT,
      ...territoryPT,
      ...organizationPT
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
